{
  "longPressMessage": "Avaa esikatselu painamalla pitkään"
}
